import { FitnessPlanPdfDownloadButton } from 'app/components/berichte/fitnessplan/FitnessPlanPdfDownloadButton';
import { FitnessTrackerPdfDownloadButton } from 'app/components/berichte/fitnesstracker/FitnessTrackerPdfDownloadButton';
import { Icon } from 'app/components/common/Icon';
import Widget, { IWidgetConsumer } from 'app/components/common/Widget';
import { WidgetNavigate } from 'app/components/common/WidgetNavigate';
import { useStore } from 'app/context';
import { AgtAdzeEmpfehlungVM } from 'app/stores/ui/agt.adzempfehlung.ui.store';
import { AgtFitnessVm } from 'app/stores/ui/agt.fitness.ui.store';
import { formatPercentWithIcon } from 'app/utils';
import _ from 'lodash';
import { observer } from 'mobx-react';
import { useEffect, useState } from 'react';
import routes from 'routes';

export const AgenturFitnessWidget = observer((props: IWidgetConsumer) => {
	const { agenturUiStore, agtFitnessUiStore, agtAdzEmpfehlungUiStore, session } = useStore();
	const agt = agenturUiStore.current;
	const [fitVm, setFitVm] = useState<AgtFitnessVm | undefined>(undefined);
	const [adzEmpfelungen, setAdzEmpfehlungen] = useState<AgtAdzeEmpfehlungVM | undefined>(undefined);

	useEffect(() => {
		agtFitnessUiStore.load().then(() => {
			let items = agtFitnessUiStore.items;
			if (agt && items.length > 0) {
				items = items.filter((i) => i.agt.agtId === agt.agtId);
				setFitVm(items[0]);
			}
		});
	});

	useEffect(() => {
		agtAdzEmpfehlungUiStore.load().then(() => {
			let items = agtAdzEmpfehlungUiStore.items;
			if (agt && items.length > 0) {
				items = items.filter((i) => i.agt.agtId === agt.agtId);
				setAdzEmpfehlungen(items[0]);
			}
		});
	});

	if (!fitVm) {
		return null;
	}
	const agtIdStr = fitVm.agt.agtId.toString();
	const navPath = routes.AGENTUR.getPath(agtIdStr, 'berichte', 'bestand', 'adz', 'fit', 'overview');

	return (
		<Widget title={'Agentur der Zukunft'} modifier="is-paddingless" widgetId={props.widgetKey} action={<WidgetNavigate text={'Zum Bericht'} path={navPath} />}>
			<div className="pad-1rem pad-bottom-0">
				<h4 className="title">Fitness Tracker</h4>
			</div>

			<div className="fitness-widget-grid">
				<div className={`fitness-grid-item bg-green`}>
					<div className="title">GUP</div>
					<div className="value">{formatPercentWithIcon(fitVm.gupBewAvg.ze)}</div>
				</div>

				<div className={`fitness-grid-item bg-turquoise`}>
					<div className="title">AMIS.NOW</div>
					<div className="value">{formatPercentWithIcon(fitVm.amisNowQuoteRead.ze)}</div>
				</div>

				{fitVm.isAkumaPrimeUser ? (
					<div className={`fitness-grid-item bg-yellow`}>
						<div className="title">AKUMA Prime</div>
						<div className="value">{formatPercentWithIcon(fitVm.primeEinordnungsquote.ze)}</div>
					</div>
				) : (
					<div className={`fitness-grid-item bg-yellow`}>
						<div className="title">AKUMA Planer</div>
						<div className="value">{formatPercentWithIcon(fitVm.planerUebertragungquoteAmisNow.ze)}</div>
					</div>
				)}

				<div className={`fitness-grid-item bg-blue`}>
					<div className="title">mAZ</div>
					<div className="value">{formatPercentWithIcon(fitVm.mazBestandDurchdringungsquote.ze)}</div>
				</div>
			</div>

			{adzEmpfelungen && session.isAdmin && (
				<>
					<div className="pad-1rem pad-bottom-0">
						<h4 className="title">Fitness Plan Empfehlungen</h4>
					</div>
					<AdzEmpfehlungenWidgetItems item={adzEmpfelungen} />
				</>
			)}

			<div className="pad-1rem grid is-col-half">
				<FitnessTrackerPdfDownloadButton modifier="is-block is-marginless" agtId={fitVm.agt.agtId} />
				<FitnessPlanPdfDownloadButton modifier="is-block is-marginless" agtId={fitVm.agt.agtId} />
			</div>
		</Widget>
	);
});

const AdzEmpfehlungenWidgetItems = observer((props: { item: AgtAdzeEmpfehlungVM }) => {
	const { agtAdzEmpfehlungUiStore } = useStore();
	const { item } = props;

	const itemsByObjectKeys = Object.keys(item.item).filter((key) => key !== 'bm' && key !== 'agtId' && key !== 'j');
	return (
		<div className="fitness-widget-grid">
			<>
				{itemsByObjectKeys.map((key) => {
					const value = _.get(item.item, key);
					if (value === 1) {
						const schema = agtAdzEmpfehlungUiStore.schema.find((r) => r.path === key);
						return (
							<div className={`fitness-grid-item bg-${schema?.color}`}>
								<h4 className="title">{schema?.label}</h4>
							</div>
						);
					}
				})}
			</>
		</div>
	);
});
